export function CircleSyncSvg() {
	return (
		<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="17" cy="17" r="16" stroke="#A12971" strokeWidth="2" />
			<path d="M17 8C12.0294 8 8 12.0294 8 17M26 17C26 21.9706 21.9706 26 17 26" stroke="#A12971" strokeWidth="2" />
			<path d="M23 8L17 11.4641L17 4.5359L23 8Z" fill="#A12971" />
			<path d="M11 26L17 22.5359L17 29.4641L11 26Z" fill="#A12971" />
		</svg>
	);
}